import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilsService } from '../utils/utils.service';

@Component({
  selector: 'app-filter-category',
  templateUrl: './filter-category.component.html',
  styleUrls: ['./filter-category.component.css']
})
export class FilterCategoryComponent {
  
  @Input() list:Array<any> = [];
  @Input() childElement:string = '';
  @Input() type:string = '';

  @Output() send = new EventEmitter<Object>();
  
  constructor(public utilsService: UtilsService) {
  }

  
  toggleItem(item: Object, parent) {

    if(!parent){

      item['checked'] = !item['checked']
  
      let elem = {
        type: this.type,
        item: item
      }
  
      this.send.emit(elem);

    }

    if(item['hidden'] === null)
      item['hidden'] = false;
    else
    item['hidden'] = !item['hidden'];

    if(item['opened'] === null)
      item['opened'] = true;
    else
    item['opened'] = !item['opened'];

  }


}
